import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { _UBLDiscrepancyResponse } from "../../../../../core/services/dataBean/EntityCatalog";

interface Props {
    idSelector?: number | null;
    onChange: any;
    label?: string;
}
export const SelectUBLDocumentTypeConstants = ({ idSelector, onChange, label }: Props) => {

    const { instance, lista, setLista, bean, setBean } = useDataBean(_UBLDiscrepancyResponse);

    const [id, setID] = useState<number | null>();

    useEffect(() => {
        getGoodTypesConstants();
    }, [])

    useEffect(() => {
        if (idSelector != id) {
            setID(idSelector ?? null);
        }
    }, [idSelector])

    const setValue = (e: any) => {
        setID(e);
        onChange(e);
    };

    const getGoodTypesConstants = () => {
            instance.getUBLDocumentTypeConstants(null).then(
                (resp: any) => {
                    setLista(resp);
                }
            ).catch(err => console.error(err))
    }

    return (
        <>
            <label>{label ? label : 'Tipo de Documento'}</label>
            <select className="form-select" value={id ?? ""} onChange={(e) => { const value = e.target.value ? Number(e.target.value) : null; setValue(value) }}>
                <option value={""} >...</option>
                {lista &&
                    lista.map((item: any) => {
                        return (
                            <option key={item.DataBeanProperties.Value} value={item.DataBeanProperties.Value} >{item.DataBeanProperties.Property}</option>
                        )
                    })
                }
            </select>
        </>
    )
}
